import { render } from "./MarketReports.vue?vue&type=template&id=4f31600a&scoped=true"
import script from "./MarketReports.vue?vue&type=script&lang=js"
export * from "./MarketReports.vue?vue&type=script&lang=js"

import "./MarketReports.vue?vue&type=style&index=0&id=4f31600a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f31600a"]])

export default __exports__